import { useTranslation } from '../../../i18n/useTranslation';
import type { TranslationKey } from '../../../i18n/he';
import './ErrorState.css';

interface ErrorStateProps {
  /** A code from the API, not a message: the copy has to exist in both locales. */
  code?: string | null;
  onRetry?: () => void;
}

const MESSAGE_FOR_CODE: Record<string, TranslationKey> = {
  NETWORK: 'errorNetwork',
  AUTH_REQUIRED: 'errorUnauthorized',
  PREMIUM_REQUIRED: 'premiumLocked',
  NOT_FOUND: 'errorNotFound'
};

/**
 * The server's own message is never shown. It is written in one language and
 * every string a user reads has to exist in both, so the code is mapped to
 * copy here and anything unrecognised falls back to the generic line.
 */
export function ErrorState({ code, onRetry }: ErrorStateProps) {
  const { tr } = useTranslation();
  const key: TranslationKey = (code ? MESSAGE_FOR_CODE[code] : undefined) ?? 'errorGeneric';
  return (
    <div className="error-state" role="alert">
      <p className="error-state-title">{tr('errorTitle')}</p>
      <p className="error-state-message">{tr(key)}</p>
      {onRetry && (
        <button type="button" className="ghost-button" onClick={onRetry}>
          {tr('retry')}
        </button>
      )}
    </div>
  );
}
